import { FC } from 'react';

import { StandardPriceModel } from 'api/pricesApi/pricesModel';
import { useFormat } from 'common/contexts/FormatContext';
import useFallbackTranslation from 'utils/hooks/useFallbackTranslation';

export interface LowestMonthPriceProps {
  price?: StandardPriceModel;
}

export const LowestMonthPrice: FC<LowestMonthPriceProps> = ({ price }) => {
  const { t } = useFallbackTranslation();
  const { formatCurrency } = useFormat();
  if (!price) return null;
  if (price.lowestPriceInLastMonth === undefined) return null;
  return (
    <div className="text-sm text-gray-700">
      {t('system.LowestPriceDescription')}
      &nbsp;
      {formatCurrency(price.lowestPriceInLastMonth)}
    </div>
  );
};
